import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { LuGlobe, LuUserCheck, LuMonitorSmartphone, LuUsers } from 'react-icons/lu';
import logo from '../../assets/logo.png'; // ajustează calea după proiectul tău
import ProjectDetails from './ProjectDetails';
import SocialShareBar from './SocialShareBar';

const ProjectCard = () => {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f3f4f6 0%, #e3e6ed 100%)",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Header Section */}
      <div style={{ position: "relative" }}>
        <div style={{
          height: 384,
          background: "linear-gradient(90deg, #01358d 0%, #1e3a8a 100%)",
          position: "relative",
          overflow: "hidden"
        }}>
          <img
            src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80"
            alt="România Globală"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: 0.25,
              position: "absolute",
              top: 0,
              left: 0
            }}
          />
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(90deg, rgba(1,53,141,0.85) 0%, rgba(30,58,138,0.7) 100%)"
          }}></div>
          <div style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div className="text-center text-white mx-auto px-3" style={{ maxWidth: 900 }}>
              <div
                className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-4"
                style={{
                  background: "rgba(255,255,255,0.10)",
                  backdropFilter: "blur(3px)"
                }}
              >
                <LuGlobe color="#FFC107" size={24} />
                <span className="fw-semibold">Proiect strategic pentru diaspora</span>
              </div>
              <h1 className="fw-bold mb-4" style={{ fontSize: "2.5rem", lineHeight: 1.1 }}>
                U-nite-D – România Globală: <br />
                <span style={{ color: "#ffc107" }}>Diaspora în Serviciul Economic Național</span>
              </h1>
              <p className="lead opacity-90 mx-auto" style={{ maxWidth: 700 }}>
                România devine o forță economică globală, valorificând potențialul diasporei! Statul va crea și susține companii românești în străinătate, angajând români din diaspora în domenii cheie precum IT, construcții, servicii medicale și transport.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Social Share Bar */}
      <SocialShareBar />

      {/* Main Content */}
      <Container className="py-5">
        {/* Project Overview Cards */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
              <Row className="mb-4">
                <Col md={4} className="mb-3 mb-md-0">
                  <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                    <div
                      className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 64,
                        height: 64,
                        background: "#FFC107",
                        borderRadius: "50%"
                      }}
                    >
                      <LuUserCheck color="#01358d" size={28} />
                    </div>
                    <h5 className="fw-semibold" style={{ color: "#01358d" }}>Companii românești în diaspora</h5>
                    <p className="text-secondary small mb-3">
                      Înființare de companii de stat sau mixte în străinătate, cu angajarea prioritară a românilor din diaspora.
                    </p>
                  </Card>
                </Col>
                <Col md={4} className="mb-3 mb-md-0">
                  <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                    <div
                      className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 64,
                        height: 64,
                        background: "#FFC107",
                        borderRadius: "50%"
                      }}
                    >
                      <LuMonitorSmartphone color="#01358d" size={28} />
                    </div>
                    <h5 className="fw-semibold" style={{ color: "#01358d" }}>Domenii strategice</h5>
                    <p className="text-secondary small mb-3">
                      IT & AI, construcții, servicii medicale, transport, agribusiness, educație – domenii cu impact și potențial de creștere.
                    </p>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                    <div
                      className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 64,
                        height: 64,
                        background: "#FFC107",
                        borderRadius: "50%"
                      }}
                    >
                      <LuUsers color="#01358d" size={28} />
                    </div>
                    <h5 className="fw-semibold" style={{ color: "#01358d" }}>Impact strategic</h5>
                    <p className="text-secondary small mb-3">
                      Economie circulară transnațională, repatriere indirectă a capitalului și expertizei, creșterea influenței României în lume.
                    </p>
                  </Card>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        {/* Project Details Component */}
        <ProjectDetails />

        {/* Footer */}
        <footer className="mt-5 mx-auto" style={{ maxWidth: 900 }}>
          <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
            <Row className="align-items-center justify-content-between">
              <Col md="auto" className="mb-3 mb-md-0 d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%"
                  }}
                >
                  <img
                    src={logo}
                    alt="PRDP"
                    width={64}
                    height={64}
                    style={{
                      borderRadius: 16,
                      background: "#ffc107",
                      marginRight: 12,
                      boxShadow: "0 2px 8px #1a2c5e",
                    }}
                  />
                </div>
                <div>
                  <h5 className="fw-bold mb-1" style={{ color: "#01358d" }}>PRDP</h5>
                  <div className="text-secondary small">Pentru o Românie globală și prosperă</div>
                </div>
              </Col>
              <Col md="auto" className="text-md-end text-center">
                <div className="d-flex align-items-center gap-2 text-primary mb-1 justify-content-md-end justify-content-center">
                  <span className="small fw-medium" style={{ color: "#01358d" }}>Decembrie 2024</span>
                </div>
                <div className="d-flex align-items-center gap-2 text-primary justify-content-md-end justify-content-center">
                  <span className="small fw-medium" style={{ color: "#01358d" }}>Alin Claudiu Mureșanu</span>
                </div>
                <div className="text-secondary small mt-1">Proiect strategic diaspora</div>
              </Col>
            </Row>
          </Card>
        </footer>
      </Container>
    </div>
  );
};

export default ProjectCard;
